module.exports = __webpack_public_path__ + "static/media/default-bg.539beb24.png";